import script from "./DashboardHome.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardHome.vue?vue&type=script&setup=true&lang=js"

import "./DashboardHome.vue?vue&type=style&index=0&id=1daa5f6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1daa5f6c"]])

export default __exports__